export const EXTRANEOUS_RESPONDERS = [
  "8d5aea75-6460-4439-8db8-2ce8987b11bc", // Incident Managers
  "cb090499-5cff-41a5-afdd-b2a695ee73cf", // Communications Officer
  "8f683002-bac7-4cb6-9762-f26805081c2b", // Executives
  "454a765c-43f9-4986-a2e0-a7a91ddf220d", // Support
];
